import "@/common/extensions/index";
import { AppPermission } from "@/core/api/generated/v1";

export class PermissionHelper {
  public static readonly presets = {
    entityAffiliationManage: (entityManagePermission: AppPermission) => [
      entityManagePermission,
      AppPermission.DepartmentManage,
      AppPermission.LocationManage,
    ],
  };
}
